import { render, staticRenderFns } from "./BatamPpvcFactory.vue?vue&type=template&id=7b615732&scoped=true"
import script from "./BatamPpvcFactory.vue?vue&type=script&lang=js"
export * from "./BatamPpvcFactory.vue?vue&type=script&lang=js"
import style0 from "./BatamPpvcFactory.vue?vue&type=style&index=0&id=7b615732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b615732",
  null
  
)

export default component.exports